<div class="d-flex flex-column">
  <p-multiSelect
    [options]="configData.data"
    [(ngModel)]="configData.selectedItems"
    [optionLabel]="configData.optionLabel"
    [optionValue]="configData.optionValue"
    [filter]="filter"
    [showToggleAll]="showToggleAll"
    [placeholder]="configData.placeholder"
    (onChange)="onChangeHandler($event)"
    [required]="isRequiredField"
    [formControl]="multiSelectFormControl"
    [resetFilterOnHide]="resetFilterOnHide"
    [ngClass]="{ 'ng-dirty ng-invalid': configData.isRequiredField }"
    [ariaLabel]="configData.ariaLabel"
    nrMultiselectAieaProp
    [ariaRequired]="isRequiredField"
    [autofocus]="configData.autofocus"
    [group]="false"
    [optionGroupLabel]="configData.optionGroupLabel || 'name'"
    [optionGroupChildren]="configData.optionGroupChildren || 'items'"
  ></p-multiSelect>
</div>
